<script lang="ts" setup>
const props = defineProps<{
  colorType: number
  textType: number
}>()

const emit = defineEmits<{
  (e: 'onButtonClick'): void
}>()
</script>

<template>
  <button
    class="cursor-pointer"
    :class="{ 'promo-code-btn': textType === 2, 'partner-button bg-white text-main-green': textType === 1 }"
    @click="emit('onButtonClick')"
  >
    <span v-if="colorType === 1">Стать партнёром iTAB</span>
    <span v-else-if="colorType === 2">Стать партнёром</span>
  </button>
</template>

<style lang="scss" scoped>
@use 'assets/css/variables';

.promo-code-btn,
.partner-button {
  border: none;
  border-radius: 15px;
  font-family: inherit;
  font-size: 20px;
  font-weight: 500;
  padding: 16px 24px;
}

.promo-code-btn {
  background: variables.$itab-gradient-to-bottom;
  color: white;

  @media (max-width: 772px) {
    padding: 20px 50px;
  }
}

.partner-button {
  @media (max-width: 768px) {
    font-size: 18px;
    width: 100%;
  }
}
</style>
